<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row" v-if="$gate.isAllowed('is_laporan')">

          <div class="col-12">
        
            <!--div class="card" v-if="$gate.isAdmin()"-->
            <div class="card">
              <div class="card-header">
                <form @submit.prevent="cariPlg()" id="formCariPlg">
                    <div class="row form">
                    <div class="input-group col-6">
                        <input v-model="form.cari_plg" type="number" name="cari_plg" class="form-control" @keydown="preventArrow($event)" required>
                        <div class="input-group-append">
                            <span class="input-group-text">@fiberterra.net</span>
                        </div> &nbsp;
                        <button type="submit" class="btn btn-primary">
                            <i class="fa fa-search"></i>
                            Cari {{ this.$route.params['id_plg']}}
                        </button>
                    </div>
                    </div>
                </form>
              </div>
              <v-app>
                <v-content>
              <!-- /.card-header -->
                <div class="card-body ">
                    <dl class="row p-3">
                        <dt class="col-sm-3 p-0">Nama Pelanggan</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['nama_orang'] }} </dd>
                        <dt class="col-sm-3 p-0">Nama Tempat Instalasi</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['nama_tempat'] }} </dd>
                        <dt class="col-sm-3 p-0">No KTP</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['no_ktp'] }} </dd>
                        <dt class="col-sm-3 p-0">Tipe</dt>
                        <dd class="col-sm-3 p-0"> 
                            {{datas_plg['tipe_langganan'] == '1' ? 'PPPOE' : '' }} 
                            {{datas_plg['tipe_langganan'] == '2' ? 'CORPORATE' : '' }} 
                        </dd>
                        <!--dt class="col-sm-3 p-0">No ID Internet</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['no_inet'] }} </dd-->
                        <dt class="col-sm-3 p-0">Telepon</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['hp'] }} </dd>
                        <dt class="col-sm-3 p-0">Email</dt>
                        <dd class="col-sm-3 p-0"> {{datas_plg['email'] }} </dd>
                        
                    </dl>
                    <div class="row ">
                        <div class="col-12">
                            <v-data-table
                                :headers="headers"
                                :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                                :items="datas"
                                :items-per-page="25"
                                item-key="id"
                                sort-by="id"
                                :sort-desc.sync="sortDesc"
                                class="elevation-1 ">
                                
                                <template v-slot:item.bulan_pemakaian="{ item }">
                                    {{ getBulan(item.bulan_pemakaian) }}
                                </template>
                                <template v-slot:item.status_bayar="{ item }">
                                    <span :class="item.status_bayar == '1' ? 'text-green' : 'text-red'">{{ item.status_bayar == '1' ? "LUNAS" : "BELUM LUNAS" }}</span>
                                </template>
                                <template v-slot:item.total_bayar="{ item }">
                                    {{ item.total_bayar | toCurrency }}
                                </template>
                                <template v-slot:item.total="{ item }">
                                    {{ item.total | toCurrency }}
                                </template>

                                <template v-slot:no-data>
                                    <h4>Data Tidak Ditemukan</h4>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </div>
                </v-content>
              </v-app>
              <!-- /.card-body -->
              <div class="card-footer">
                  
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAllowed('is_laporan')">
            <not-found></not-found>
        </div>

        
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                sortDesc : true,
                datas_plg : [],
                datas : [],
                form: new Form({
                    cari_plg : '',
                }),
                headers: [
                  { text: 'Periode Pakai', align: 'start', value: 'bulan_pemakaian', sortable: false, groupable: false, },
                  { text: 'Paket', align: 'start', value: 'nama_paket', sortable: false, groupable: false, },
                  { text: 'Jumlah Tagihan', align: 'start', value: 'total', sortable: false, groupable: false, },
                  { text: 'Jumlah Bayar', align: 'start', value: 'total_bayar', sortable: false, groupable: false, },
                  { text: 'Status', align: 'start', value: 'status_bayar', sortable: false, groupable: false, },
                  { text: 'Lokasi Bayar', align: 'start', value: 'sumber_bayar', sortable: false, groupable: false, },
                  { text: 'Tanggal Bayar', align: 'start', value: 'tanggal_bayar', sortable: false, groupable: false, },
                ],
            }
        },
        methods: {
            cariPlg(){
                this.$Progress.start();
                if(this.$gate.isAllowed("is_laporan")){
                    //axios({ url: "api/laporan/riwayat?no_internet="+this.form.cari_plg, baseURL:"/api/" }).then(({ data }) => {
                    axios.get("api/laporan/riwayat?no_internet="+this.form.cari_plg).then(({ data }) => {
                        console.log(data);
                        if(data.data.biodata.length > 0){
                            this.datas_plg = data.data.biodata[0];
                            this.datas = data.data.riwayat;
                            this.$Progress.finish();
                        }else{
                            this.datas_plg = [];
                            this.datas = [];
                             Toast.fire({
                                icon: 'error',
                                title: "Error!. Data Pelanggan Tidak Ditemukan."
                            });
                            this.$Progress.fail();
                        }
                    });
                }
            
            },
            preventArrow(e) {
             
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
                if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57)
                {
                    e.preventDefault();
                }
            
           
            },
            getBulan(tanggal){
                var tgltemp = new Date(tanggal);
                var tahun = tgltemp.getFullYear();
                var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
                
                return (bulan[tgltemp.getMonth()] + " " + tahun);
            },
        },
        mounted() {
            
        },
        created() {
            
            if(this.$route.query.id){
                this.form.cari_plg = this.$route.query.id;
                this.cariPlg();
            }
        }
    }
</script>

<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>